import React, { useState, useEffect } from "react";
import "../styles/GoogleLoginButton.css";

const GoogleLoginButton = ({
  onSuccess,
  onError,
  text = "Sign up with Google"
}) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (!window.google) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = () => setScriptLoaded(true);
      script.onerror = () => onError?.("Failed to load Google API");
      document.head.appendChild(script);
    } else {
      setScriptLoaded(true);
    }
  }, [onError]);

  useEffect(() => {
    if (scriptLoaded && window.google) {
      initializeGoogleSignIn();
    }
  }, [scriptLoaded]);

  const initializeGoogleSignIn = () => {
    try {
      window.google.accounts.id.initialize({
        client_id:
          "539759608837-33llnc3ko9e9g94od82a78tn30agvnnq.apps.googleusercontent.com",
        callback: handleCredentialResponse,
        auto_select: false,
        ux_mode: "popup"
      });

      window.google.accounts.id.renderButton(
        document.getElementById("googleSignInButton"),
        {
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "rectangular",
          logo_alignment: "left",
          width: 300
        }
      );
    } catch (error) {
      console.error("Google Sign-In initialization error:", error);
      onError?.("Google Sign-In initialization failed");
    }
  };

  const handleCredentialResponse = (response) => {
    if (response.credential) {
      onSuccess(response.credential);
    } else {
      onError?.("Google Sign-In failed");
    }
  };

  return (
    <div className="google-login-container">
      <div id="googleSignInButton">
        <button className="google-login-button" type="button">
          <span className="google-icon">
            <svg width="18" height="18" viewBox="0 0 18 18">
              <path
                fill="#4285F4"
                d="M16.51 8.36v1.47h-4.4v2.32h2.54c-.33 1.56-1.38 2.28-2.54 2.28-1.54 0-2.8-1.25-2.8-2.8s1.25-2.8 2.8-2.8c0.7 0 1.33 0.26 1.82 0.68l1.24-1.24c-0.85-0.79-1.96-1.27-3.06-1.27-2.53 0-4.59 2.06-4.59 4.59s2.06 4.59 4.59 4.59c2.21 0 4.11-1.57 4.59-3.74h-4.59v-1.47h7.34z"
              />
            </svg>
          </span>
          <span className="google-button-text">{text}</span>
        </button>
      </div>
    </div>
  );
};

export default GoogleLoginButton;
